module.exports = __webpack_public_path__ + "static/media/2-3-3_OPP_Rainbow_02.c2a494eb.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/printing-information/Printing-Techniques/2-3-3_OPP_Rainbow_02.jpg
// module id = 1723
// module chunks = 0